<template>
  <Modal v-if="show" @close="$emit('update:show',false)">
      <div class="card-n">
        <div class="card-title">{{$t('home.components.activation.queryRes')}}{{$t('home.components.activation.fileName',{name:fileName})}}</div>
        <div class="card-body">
          <table class="table-layout">
            <thead>
              <tr>
                <th> {{$t('home.components.activation.capFileID')}}</th>
                <th> {{$t('home.components.activation.activeAmount')}}</th>
                <th> {{$t('home.components.activation.A_status')}}</th>
              </tr>
            </thead>
            <tbody v-if="list && list.length">
              <tr v-for="(item,i) in list" :key="i">
                <td :title="item.target">{{item.target | textcut(5)}}</td>
                <td>{{item.amount}}</td>
                <td>{{item.amount > 0 ? $t('home.components.activation.A_status_success') : $t('home.components.activation.UA_status')}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </Modal>
</template>
<script>
export default {
  props:['show','list','fileName']
}
</script>
<style lang="scss" scoped>
.card-n{
  padding: 2rem 2rem;
  background: url('~@/assets/image/modal_sm.png') no-repeat;
  background-size: 100% 100%;
  width: 500px;
  height: 456px;
  .card-title{
    width: 100%;
    border-bottom: 0.1rem solid rgba(222,222,222,0.4);
    padding-bottom: 2rem;
    float: left;
    color: #333333;
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 2rem;
    position: relative;
  }
  .table-layout tbody{
 
  height: 278px;

}
}
</style>